module.exports = __webpack_public_path__ + "img/home_4.d0b48b7f.svg";